module.exports = __webpack_public_path__ + "static/img/service_h5_01_zh.c3bbd17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_h5_01_zh.png
// module id = dXjj
// module chunks = 34